import { motion } from 'framer-motion';
import { memo } from 'react';
import { useLocation } from 'react-router-dom';

import { NavigatorButton } from './subComponents/NavigatorButton';

/**
 * Main Navigator component that renders the breadcrumb navigation
 *
 * This component is memoized for performance and includes animations
 * with Framer Motion for a smooth user experience.
 */
export const Breadcrumbs = memo(() => {
  const { pathname } = useLocation();

  if (pathname === '/' || pathname.includes('/auth')) {
    return null;
  }

  return (
    <motion.nav
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
      aria-label="Breadcrumb"
      data-testid="breadcrumb-navigation"
      className="relative z-20"
    >
      <div className="flex items-center space-x-4">
        <NavigatorButton />
      </div>
    </motion.nav>
  );
});

Breadcrumbs.displayName = 'Breadcrumbs';
